import styles from './Card.module.scss';

interface CardProps {
  title: string | React.ReactNode;
  children?: React.ReactNode;
}

export default function Card({ title, children }:CardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.title}>
        {title}
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
}
